import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  border-bottom: 2px solid #e1ad21;
  background-color: #0a192f;
  backdrop-filter: blur(10px);
`;

const Container = styled.div`
  display: flex;
  height: 64px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Logo = styled(Link)`
  font-family: "Righteous-Regular";
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #cec9ab;
  font-size: 1.5rem;
  font-weight: bold;
`;

const NavigationMenu = styled.nav`
  margin-left: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavigationMenuList = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const NavigationMenuItem = styled.li`
  margin-right: 1rem;
`;

const NavigationMenuLink = styled(NavLink)`
  font-family: "Raleway-Regular";
  text-decoration: none;
  color: #cec9ab;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  transition: color 0.3s, background-color 0.3s;

  &:hover {
    color: #e1ad21;
    background-color: rgba(252, 252, 252, 0.1);
  }

  &.active {
    color: #e1ad21;
    font-weight: bold;
  }
`;

const ContactButton = styled(Link)`
  font-family: "Raleway-Regular";
  background-color: #cec9ab;
  color: #0a192f;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  text-decoration: none;
  transition: background-color 0.3s;
  margin-left: auto;

  &:hover {
    color: #e1ad21;
    background-color: rgba(252, 252, 252, 0.1);
  }

  &.active {
    color: #e1ad21;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #cec9ab;
  font-size: 1.5rem;
  cursor: pointer;
  margin-left: auto;

  @media (max-width: 768px) {
    display: block;
  }
`;

// Changed: Use $isOpen (transient prop) instead of isOpen
const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  background-color: #0a192f;
  padding: 1rem;

  @media (max-width: 768px) {
    display: ${props => props.$isOpen ? 'block' : 'none'};
  }
`;

const MobileMenuLink = styled(NavLink)`
  font-family: "Raleway-Regular";
  display: block;
  text-decoration: none;
  color: #cec9ab;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
  transition: color 0.3s, background-color 0.3s;

  &:hover {
    color: #e1ad21;
    background-color: rgba(252, 252, 252, 0.1);
  }

  &.active {
    color: #e1ad21;
    font-weight: bold;
  }
`;

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HeaderWrapper>
      <Container>
        <Logo to="/">NueDesign</Logo>
        <NavigationMenu>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuLink to="/services">Services</NavigationMenuLink>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink to="/pricing">Pricing</NavigationMenuLink>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink to="/gallery">Gallery</NavigationMenuLink>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink to="/about">About</NavigationMenuLink>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
        <ContactButton to="/contact">Contact Us</ContactButton>
        <MobileMenuButton onClick={toggleMobileMenu}>☰</MobileMenuButton>
      </Container>
      {/* Changed: isOpen -> $isOpen */}
      <MobileMenu $isOpen={isMobileMenuOpen}>
        <MobileMenuLink to="/services" onClick={toggleMobileMenu}>Services</MobileMenuLink>
        <MobileMenuLink to="/pricing" onClick={toggleMobileMenu}>Pricing</MobileMenuLink>
        <MobileMenuLink to="/gallery" onClick={toggleMobileMenu}>Gallery</MobileMenuLink>
        <MobileMenuLink to="/about" onClick={toggleMobileMenu}>About</MobileMenuLink>
        <MobileMenuLink to="/contact" onClick={toggleMobileMenu}>Contact Us</MobileMenuLink>
      </MobileMenu>
    </HeaderWrapper>
  );
};

export default Header;
